import { Pagination, Table } from '@maia/ui';
import { useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useFilter } from '../../../utils/filter/filter';
import { Quotations, getQuotationsOptions } from './queryOptions';
import { useQuotationsTable } from './tableOptions';

interface QuotationsTableProps {
  quotations: Quotations;
}

export function QuotationsTable(props: QuotationsTableProps) {
  const { quotations } = props;
  const { guid } = useParams({
    from: '/_authenticated/customers/$guid/_layout/quotations',
  });
  const { dispatch: setSearch, mappedState } = useFilter(
    '/customers/$guid/quotations',
  );

  const { data } = useQuery(
    getQuotationsOptions(guid, mappedState, quotations),
  );

  const table = useQuotationsTable(data);
  const { sorting } = table.getState();

  useEffect(() => {
    setSearch({ type: 'setSort', payload: sorting });
  }, [setSearch, sorting]);

  return (
    <Table
      table={table}
      className="grid-cols-[min-content_min-content_auto_min-content_min-content]"
      paginationSlot={
        data?.pagination ? (
          <Pagination
            {...data.pagination}
            onLimitChange={(limit) =>
              setSearch({ type: 'setLimit', payload: limit })
            }
            onPageChange={(page) =>
              setSearch({ type: 'paginate', payload: page })
            }
          />
        ) : null
      }
    />
  );
}
